import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/renameoperation
 */
import Operation from './operation';
import Element from '../element';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import Position from '../position';
/**
 * Operation to change element's name.
 *
 * Using this class you can change element's name.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var RenameOperation = /*#__PURE__*/function (_Operation) {
  _inherits(RenameOperation, _Operation);

  var _super = _createSuper(RenameOperation);

  /**
   * Creates an operation that changes element's name.
   *
   * @param {module:engine/model/position~Position} position Position before an element to change.
   * @param {String} oldName Current name of the element.
   * @param {String} newName New name for the element.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function RenameOperation(position, oldName, newName, baseVersion) {
    var _this;

    _classCallCheck(this, RenameOperation);

    _this = _super.call(this, baseVersion);
    /**
     * Position before an element to change.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/renameoperation~RenameOperation#position
     */

    _this.position = position; // This position sticks to the next node because it is a position before the node that we want to change.

    _this.position.stickiness = 'toNext';
    /**
     * Current name of the element.
     *
     * @member {String} module:engine/model/operation/renameoperation~RenameOperation#oldName
     */

    _this.oldName = oldName;
    /**
     * New name for the element.
     *
     * @member {String} module:engine/model/operation/renameoperation~RenameOperation#newName
     */

    _this.newName = newName;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RenameOperation, [{
    key: "type",
    get: function get() {
      return 'rename';
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/renameoperation~RenameOperation} Clone of this operation.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new RenameOperation(this.position.clone(), this.oldName, this.newName, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/renameoperation~RenameOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new RenameOperation(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      var element = this.position.nodeAfter;

      if (!(element instanceof Element)) {
        /**
         * Given position is invalid or node after it is not instance of Element.
         *
         * @error rename-operation-wrong-position
         */
        throw new CKEditorError('rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.', this);
      } else if (element.name !== this.oldName) {
        /**
         * Element to change has different name than operation's old name.
         *
         * @error rename-operation-wrong-name
         */
        throw new CKEditorError('rename-operation-wrong-name: Element to change has different name than operation\'s old name.', this);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      var element = this.position.nodeAfter;
      element.name = this.newName;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(RenameOperation.prototype), "toJSON", this).call(this);

      json.position = this.position.toJSON();
      return json;
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "className",
    get: function get() {
      return 'RenameOperation';
    }
    /**
     * Creates `RenameOperation` object from deserialized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/attributeoperation~AttributeOperation}
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      return new RenameOperation(Position.fromJSON(json.position, document), json.oldName, json.newName, json.baseVersion);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `RenameOperation( ${ this.baseVersion } ): ` +
    // @if CK_DEBUG_ENGINE //		`${ this.position }: "${ this.oldName }" -> "${ this.newName }"`;
    // @if CK_DEBUG_ENGINE // }

  }]);

  return RenameOperation;
}(Operation);

export { RenameOperation as default };